// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/login_background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    min-height: 100vh;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
}

/* -- Login Box -- */

.wrapper {
    display: flex;
    flex-direction: column;
    width: 500px;
    font-size: 1.1rem;
    color: #FFF;
    border: 2px solid rgba(255, 255, 255, .2);
    border-radius: 10px;
    background: transparent;
    backdrop-filter: blur(20px);
    box-shadow: 0 0 10px rgba(0, 0, 0, .2);
    padding: 2rem;
}

.logo-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.logo {
    width: 35%;
}

/* -- Login Box - Inputs -- */

.input-box {
    position: relative;
    width: 100%;
    height: 50px;
    margin: 30px 0;
}

.input-box input {
    width: 100%;
    height: 100%;
    background: transparent;
    outline: none;
    border: 2px solid rgba(255, 255, 255, .2);
    border-radius: 40px;
    font-size: 16px;
    color: #FFF;
    padding: 20px;
}

.input-box input::placeholder {
    color: #FFF;
}

.input-box i {

    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 20px;
}

/* -- Remember - Forgot -- */

.remember-forgot {
    display: flex;
    justify-content: space-around;
    font-size: 1rem;
    margin: 1rem 0;
}

.remember-forgot label {
    display: flex;
    align-items: center;
    justify-content: center;
}

.remember-forgot label input {
    accent-color: #FFF;
    margin-right: 10px;
}

input[type="checkbox"] {
    width: 1rem;
    height: 1rem;
}

#forgot-password {
    background: none;
    border: none;
    font-size: 1rem;
    font-weight: 600;
    color: #FFF;
    cursor: pointer;
}

#forgot-password:hover {
    text-decoration: underline;
    color: #8CBA0B;
}

/* -- Button -- */

.btn-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 30px 0 20px 0;
}

/* -- Wrapper Footer -- */

.powered {
    text-align: center;
    font-size: 0.7rem;
    margin-top: 25px;
}

.powered p {
    color: #FFF;
}   

.powered a {
    text-decoration: none;
    color: #FFF;
    font-weight: 600;
}

.powered a:hover {
    text-decoration: underline;
    color: #8CBA0B;
}`, "",{"version":3,"sources":["webpack://./src/css/sg-login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,yDAAqD;IACrD,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA,oBAAoB;;AAEpB;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,yCAAyC;IACzC,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,sCAAsC;IACtC,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA,6BAA6B;;AAE7B;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,yCAAyC;IACzC,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,eAAe;AACnB;;AAEA,4BAA4B;;AAE5B;IACI,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA,iBAAiB;;AAEjB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,yBAAyB;;AAEzB;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB","sourcesContent":[".body {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    min-height: 100vh;\n    background-image: url(../assets/login_background.jpg);\n    background-size: cover;\n    background-position: center;\n}\n\n/* -- Login Box -- */\n\n.wrapper {\n    display: flex;\n    flex-direction: column;\n    width: 500px;\n    font-size: 1.1rem;\n    color: #FFF;\n    border: 2px solid rgba(255, 255, 255, .2);\n    border-radius: 10px;\n    background: transparent;\n    backdrop-filter: blur(20px);\n    box-shadow: 0 0 10px rgba(0, 0, 0, .2);\n    padding: 2rem;\n}\n\n.logo-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.logo {\n    width: 35%;\n}\n\n/* -- Login Box - Inputs -- */\n\n.input-box {\n    position: relative;\n    width: 100%;\n    height: 50px;\n    margin: 30px 0;\n}\n\n.input-box input {\n    width: 100%;\n    height: 100%;\n    background: transparent;\n    outline: none;\n    border: 2px solid rgba(255, 255, 255, .2);\n    border-radius: 40px;\n    font-size: 16px;\n    color: #FFF;\n    padding: 20px;\n}\n\n.input-box input::placeholder {\n    color: #FFF;\n}\n\n.input-box i {\n\n    position: absolute;\n    right: 20px;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 20px;\n}\n\n/* -- Remember - Forgot -- */\n\n.remember-forgot {\n    display: flex;\n    justify-content: space-around;\n    font-size: 1rem;\n    margin: 1rem 0;\n}\n\n.remember-forgot label {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.remember-forgot label input {\n    accent-color: #FFF;\n    margin-right: 10px;\n}\n\ninput[type=\"checkbox\"] {\n    width: 1rem;\n    height: 1rem;\n}\n\n#forgot-password {\n    background: none;\n    border: none;\n    font-size: 1rem;\n    font-weight: 600;\n    color: #FFF;\n    cursor: pointer;\n}\n\n#forgot-password:hover {\n    text-decoration: underline;\n    color: #8CBA0B;\n}\n\n/* -- Button -- */\n\n.btn-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 30px 0 20px 0;\n}\n\n/* -- Wrapper Footer -- */\n\n.powered {\n    text-align: center;\n    font-size: 0.7rem;\n    margin-top: 25px;\n}\n\n.powered p {\n    color: #FFF;\n}   \n\n.powered a {\n    text-decoration: none;\n    color: #FFF;\n    font-weight: 600;\n}\n\n.powered a:hover {\n    text-decoration: underline;\n    color: #8CBA0B;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
